import React from 'react'

function Paynow() {
  return (
    <div>PayNow</div>
  )
}

export default Paynow